import { h } from "preact";
import { useRef } from "preact/hooks";

import { JiraAttachmentDetails } from "../../../../foundation/model/JiraAttachment";
import classname from "../../../../foundation/utils/classname";
import PopoverWithHover from "../../Popover/PopoverWithHover";
import { PopoverAlignment, PopoverMode, PopoverPosition, PopoverProps } from "../../Popover";
import JiraIssueCard from "../JiraIssueCard";

import styles from "./JiraAttachmentLink.module.css";

const POPOVER_PADDING = 12;
const POPOVER_DELAY = 200;

type Props = {
    class?: string;
    issueKey: string;
    details?: JiraAttachmentDetails;
    href: string | undefined;
    popoverProps?: PopoverProps;
    onClick?: (openInJira?: boolean) => void;
};

export default function JiraAttachmentLink({
    class: cssClass,
    issueKey,
    details,
    href,
    popoverProps = {},
    onClick
}: Props) {
    const linkRef = useRef<HTMLAnchorElement>();

    const link = (
        <a
            ref={linkRef}
            class={classname(styles.jiraAttachmentLink, "body-1", cssClass)}
            href={href}
            target="_blank"
            rel="noopener noreferrer">
            {issueKey}
        </a>
    );

    if (!details) {
        return link;
    }

    return (
        <PopoverWithHover
            class={styles.jiraAttachmentLinkPopover}
            mode={PopoverMode.Portal}
            portalOptions={{
                targetRef: linkRef
            }}
            scrollContainerOptions={{
                padding: POPOVER_PADDING
            }}
            position={PopoverPosition.Bottom}
            alignment={PopoverAlignment.Start}
            offset={4}
            hideArrow
            showDelay={POPOVER_DELAY}
            hideDelay={POPOVER_DELAY}
            {...popoverProps}
            content={(
                <JiraIssueCard
                    issueKey={issueKey}
                    details={details}
                    href={href}
                    onClick={onClick}/>
            )}>
            {link}
        </PopoverWithHover>
    );
}
